import { render } from "./AddToBagTile.vue?vue&type=template&id=66487528&scoped=true"
import script from "./AddToBagTile.vue?vue&type=script&lang=js"
export * from "./AddToBagTile.vue?vue&type=script&lang=js"

import "./AddToBagTile.vue?vue&type=style&index=0&id=66487528&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66487528"]])

export default __exports__